// extracted by mini-css-extract-plugin
export var articles = "articles-module--articles--mo0z8";
export var articles__title = "articles-module--articles__title--G3rby";
export var articles__container = "articles-module--articles__container--z5sTm";
export var articles_count_1 = "articles-module--articles_count_1--z9HJ3";
export var articles_count_2 = "articles-module--articles_count_2--IXV9l";
export var articles_count_3 = "articles-module--articles_count_3--VH+6t";
export var articles_count_4 = "articles-module--articles_count_4--UyVl3";